import moment from "moment";
import * as React from "react";
import { useSelector } from "react-redux";
import api from "../../../../../api";
import {
  ILeadAction,
  Lead,
  getMinutes,
  DateFormats,
  State,
} from "../../../../../core";
import { useAppSettings } from "../../../../../core/hooks/useAppSettings";
import { combineDateAndTime } from "../../../../../utils/CombineDateAndTime";
import AddInterestedProject from "../../../../leads/components/actions/AddInterestedProject";
import ConvertAsEnquiry from "../../../../leads/components/actions/ConvertAsEnquiry";
import MapLeadQuality from "../../../../leads/components/actions/MapLeadQuality";
import { EditEventPopup } from "../../../../leads/components/activities/edit-event-popup";

interface IActionModalProps {
  onClose?: () => void;
  action: ILeadAction;
  leads?: Lead[];
  reload?: () => void;
  companyId?: string;
  companyName?: string;
  activityCategory?: string;
  activityCategoryId?: string;
}

const ActionModal: React.FunctionComponent<IActionModalProps> = (props) => {
  const authState = useSelector((state: State) => state.authUser);
  const appSettings = useAppSettings(api.settings);

  const minimumDurationInMinutes = getMinutes(
    appSettings?.data?.activity?.activityMinimumDuration || {
      value: 15,
      unit: "Minutes",
    }
  );

  const startDateTime = combineDateAndTime(
    moment().startOf("day").toDate(),
    appSettings?.data?.application?.appointmentTime?.start || "9:30 AM"
  );

  const renderVehicleForm = () => {
    return (
      <AddInterestedProject
        className="col-4"
        onClose={props.onClose}
        leads={props.leads}
        onSuccess={() => {
          props.onClose?.();
          props.reload?.();
        }}
      ></AddInterestedProject>
    );
  };

  const renderConvertAsEnquiryForm = () => {
    return (
      <ConvertAsEnquiry
        // leads={props.leads?.filter((l)=>!l.isDeal)}
        leads={props.leads?.filter((l) => !l.isDeal)}
        className="col-4"
        onSuccess={() => {
          props.onClose?.();
          props.reload?.();
        }}
        onClose={props.onClose}
        actionId={props.action._id}
      ></ConvertAsEnquiry>
    );
  };
  const renderMapLeadQualityForm = () => {
    return (
      <MapLeadQuality
        leads={props.leads}
        className="col-4"
        onSuccess={() => {
          props.onClose?.();
          props.reload?.();
        }}
        onClose={props.onClose}
      ></MapLeadQuality>
    );
  };

  const wrapInModal = (children: React.ReactNode) => {
    return (
      <>
        {" "}
        <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
          <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
            <div className="row align-items-center">
              <div className="col-auto" onClick={props.onClose}>
                <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
              </div>
              <div className="col">
                <h5 className="mb-0">{props.action.name}</h5>
              </div>
            </div>
          </div>
          <div className="container-fluid px-0 h-100">{children}</div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    );
  };
  if (
    props.action.code === "requestACallBack" ||
    props.action.code === "scheduleAShowroomVisit" ||
    props.action.code === "call" ||
    props.action.code === "scheduleATestDrive"
  ) {
    return (
      <EditEventPopup
        action={props.action}
        isEdit={false}
        currentActivity={{
          type: props.action.code,
          title: "",
          timePeriod: {
            startDate: new Date(),
            startTime:
              appSettings?.data?.application?.appointmentTime?.start ||
              "9:00 AM",
            endTime:
              moment(startDateTime)
                .add(minimumDurationInMinutes, "minute")
                .format(DateFormats.TimeOnlyFormat) || "9:30 AM",
          },
          showRoom: props.leads?.[0]?.showroom
            ? {
                _id: props.leads?.[0]?.showroom?._id || "",
                title: props.leads?.[0]?.showroom?.title,
              }
            : undefined,
          salesPerson:
            props.action.code === "call" && authState.profile
              ? {
                  _id: authState.profile?._id || "",
                  name: authState.profile?.name,
                  knownAs: authState.profile?.knownAs,
                }
              : props.leads?.[0]?.currentSalesPerson
              ? {
                  _id: props.leads?.[0]?.currentSalesPerson?._id || "",
                  name: props.leads?.[0]?.currentSalesPerson?.name,
                  knownAs: props.leads?.[0]?.currentSalesPerson?.knownAs,
                }
              : undefined,

          busyEvent: true,
          company: { "_id" : props?.companyId , 'name':props?.companyName}
        }}
        onClose={() => {
          // setFormModal({});

          props.onClose?.();
          if (props.companyId || props.activityCategoryId) {
            props.reload?.();
          }
          // props.reload?.();
        }}
        onSubmit={(updatedEvent) => {
          // onSubmitActivity(updatedEvent);
        }}
        leads={props.leads}
        companyId={props?.companyId}
        activityCategory={props?.activityCategory}
        activityCategoryId={props?.activityCategoryId}
        loadCurrentTime
      ></EditEventPopup>
    );
  }
  if (props.action.code === "addANewVehicle") {
    return wrapInModal(renderVehicleForm());
  }
  if (props.action.code === "mapLeadQuality") {
    return wrapInModal(renderMapLeadQualityForm());
  }

  if (props.action.code === "convertAsEnquiry") {
    return renderConvertAsEnquiryForm();
  }
  return <></>;
};

export default ActionModal;
